import { render, staticRenderFns } from "./gestionesEnRevision.vue?vue&type=template&id=1a4b0986&scoped=true"
import script from "./gestionesEnRevision.vue?vue&type=script&lang=js"
export * from "./gestionesEnRevision.vue?vue&type=script&lang=js"
import style0 from "./gestionesEnRevision.vue?vue&type=style&index=0&id=1a4b0986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b0986",
  null
  
)

export default component.exports